module.exports = __webpack_public_path__ + "static/img/Group 823@2x.1a67eb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/Group 823@2x.png
// module id = yHTP
// module chunks = 1